import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

/**
   * Recupera data de archivo excel para generar descarga
   * @param {object} params - datos de filtro
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.1.0 - Febrero 2024 - se agregan filtros
   */
  const getAlldetailPaymentByFilters = async (params, an8) => {

    const data = {
      startDate: params.startDate ? params.startDate : '',
      endDate: params.endDate ? params.endDate : '',
      invoice: params.invoice ? params.invoice : null,
      typeInvoice: params.typeInvoice ? params.typeInvoice : '',
      expirationDateStart: params.startExpirationDate ? params.startExpirationDate : null,
      expirationDateEnd: params.endExpirationDate ? params.endExpirationDate : null
    };

    const url = `${ baseUrl }/invoice/${an8}`;

    const token = await authHeader();

    return axios
      .get(url, {
        params: data,
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };


  const getNotificationPayment = async (dataPayment) => {


    const token = await authHeader();

    return axios
      .get(`${ baseUrl }/bbva/${dataPayment.mp_reference}` ,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  const startPayment = async (reference, paymentArray, an8) => {

    const dataPayment = {
      "reference":reference,
      "bill": paymentArray
    };

    const token = await authHeader();
    let url
    switch(paymentArray[0].bankName){
      case "bbva" : url= `${ baseUrl }/bbva/save/${an8}`;break;
      case "bajio" : url  = `${ baseUrl }/operation/multipagos/save/${an8}`
    }
    //const url = `${ baseUrl }/bbva/save/${an8}`;


    return axios
      .post(url,dataPayment,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  const cancelPayment = async (dataPayment, an8) => {


    const token = await authHeader();
    const url = `${ baseUrl }/operation/multipagos/delete-payment/${an8}`;

    return axios
      .post(url,dataPayment,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  const cancelAdvancePayment = async (dataPayment, an8) => {


    const token = await authHeader();
    const url = `${ baseUrl }/operation/multipagos/delete-advance/${an8}`;

    return axios
      .post(url,dataPayment,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  /**
   * Envía la información que se usará para la solicitud al banco
   * @param {object} request - objeto que se envia al banco
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Marzo 2024
   */
  const savePaymentRequest = async (request, an8) => {
    console.log(request)

    const token = await authHeader();
    const url = `${ baseUrl }/payment-record/save/${an8}`;

    return axios
      .post(url,request,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  const downloadPayment = async (data) => {


    const url = `${ baseUrl }/invoice/pdf-xml`;
    const token = await authHeader();

    return axios
    .get(url, {
      params: data,
      headers: token 
    },
    {
      responseType: 'blob'
    }
    )
    .then(response => {
      return response.data;
      }
      )
  };

  /**
   * Recupera data de archivo excel para generar descarga
   * @param {object} dataPayments - datos de pagos recuperados
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */
  const downloaddataPaymentsDetailXlsx = async (dataPayments, an8) => {
    const url = `${ baseUrl }/invoice/excel/${an8}`;
    const token = await authHeader();
  
    return axios
      .post(url,dataPayments, {
        headers: token 
      },
      {
        responseType: 'blob'
      }
      )
      .then(response => {
        return response.data;
        }
        )
  };
  
  const getConcepts = async () => {
    
    const url = `${ baseUrl }/paymentConcept`;

    const token = await authHeader();

    return axios
      .get(url,
        {
            headers: token 
        }
      )
      .then(response => {
        return response.data;
      }
      )
  };

  const startAdvancePayment = async (dataPayment, an8) => {

    const token = await authHeader()
    let url
    switch(dataPayment.bankName){
      case "bbva" : url= `${ baseUrl }/bbva/anticipation/${an8}`;break;
      case "bajio" : url  = `${ baseUrl }/operation/multipagos/save/advance/${an8}`;break;
      default:return null;
    }
    return axios
      .post(url,dataPayment,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };

  /**
   * Recupera estado de pago pendiente por an8
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Dociembre 2023
   */
  
  const getstatusPendingPayment = async (an8) => {


    const token = await authHeader();
  
    return axios
      .get(`${ baseUrl }/invoice/pending-invoices/${an8}` ,{
        headers: token 
      }
      )
      .then(response => {
        return response.data;
       }
       )
  };
  const getstatusCashPayment = async (an8) =>{
    const token = await authHeader();

    return axios
    .get(`${baseUrl}/bbva/cash-payment/${an8}`,{
      headers: token
    }
  ).then(response =>{
    return response.data
  })
  }
  const getInvoicesType =  async() => {

    const url = `${ baseUrl }/invoice/type-Invoice`;
  
    const token = await authHeader();
  
    return axios.get(url,
      { headers: token }
      ).then(
        (response) => {
          return response.data;
    })
  };
  const startBajioPayment = async(data)=>{
    const url = `${baseUrl}/payment/request/bajio`
    const token = await authHeader()

    return  axios.post(url,data,{
      headers:token
    }).then(
      (response)=>{
        return response.data
      }
    )
  }
  const getDetailsPayment = async(data,an8) => {
    const url  = `${baseUrl}/payment/detail?an8=${an8}&authorization=${data.authorizationNumber || data.authorization}&amount=${data.amount}`
    const token = await authHeader()
    return axios.get(url,{
      headers: token
    }).then(
      (response) => {
        return response.data
      }
    )
  }
  const getReferenceDetailService = async (referenceType, reference="", startDate="", endDate="", amountFrom="", amountUpTo="") => {
    const url = `${baseUrl}/payment-log/detail`;
    const token = await authHeader();
   

    const data = {
      filter: referenceType,
      reference: reference,
      startDate,
      endDate,
      amountFrom,
      amountUpTo

    }
    return axios.post(url,data, {
      headers: token,
    },
    
  ).then(
      (response) => {
        return response.data;
      }
    )
  }
  const updateReferenceService = async (dataPayment, reference) =>{
    const {id, amount,paymentPay} = dataPayment
    const url = `${baseUrl}/payment-log/update/${id}`;
    const token = await authHeader();
    return axios.put(url, { amount, reference, paymentPay }, {
      headers: token
    }).then(
      (response) => {
        return response.data;
      }
    )
  }
  const canUserPayWithBank  = async (an8) =>{
    const url = `${baseUrl}/operation/multipagos/can-pay/${an8}`;
    const token = await authHeader();
    return axios.get(
      url,
      {headers: token}
    ).then((response) =>{
      return response.data
    })
  }
  export default {
    downloaddataPaymentsDetailXlsx,
      getAlldetailPaymentByFilters,
      updateReferenceService,
      getstatusCashPayment,
      getNotificationPayment,
      downloadPayment,
      startPayment,
      cancelPayment,
      cancelAdvancePayment,
      savePaymentRequest,
      getConcepts,
      startAdvancePayment,
      getstatusPendingPayment,
      getInvoicesType,
      startBajioPayment,
      getDetailsPayment,
      getReferenceDetailService,
      canUserPayWithBank
    }